var r = function(e) {
  return Object.freeze(e);
};
export {
  r as freeze
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/freeze.js
// module id = 304
// module chunks = 67